import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";
import {
  desktopHeadingFontSizes,
  mobileHeadingFontSizes,
} from "plos/src/styles/typography";
import pattern1 from "../../img/pattern/pattern-1-1236.png";

export const loggedUserDiv = style({
  margin: `0 ${vars.space.m}`,
});

export const loggedUserText = style({
  marginBottom: vars.space.m,
});

export const textContainerStyles = style({
  flex: "0 0 40%",
  color: vars.colors.onPrimaryFixed,
  "@media": {
    [`(min-width: ${breakpoints[6]})`]: {
      flexBasis: "30%",
    },
  },
});

export const desktopOnlyHeading = style({
  marginBottom: vars.space.m,
  fontFamily: vars.fonts.bold,
  fontSize: mobileHeadingFontSizes["xl"],
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      marginBottom: vars.space.xs,
      fontSize: desktopHeadingFontSizes["xl"],
    },
  },
});

export const textStyles = style({
  marginBottom: vars.space.l,
  color: vars.colors.onPrimaryFixed,
});

export const buttonContainerStyles = style({
  display: "flex",
  gap: vars.space.xs,
});

export const imageStyles = style({
  borderRadius: vars.radii.l,
  backgroundImage: `url(${pattern1})`,
  backgroundPosition: "right -141px top -142px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "366px 533px, auto",
  width: "100%",
  maxWidth: 400,
  selectors: {
    '[dir="rtl"] &': {
      backgroundPosition: "left -141px top -142px",
    },
  },
});
